import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({ providedIn: "root" })
export class GeofencingConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isArgentinaGeofencingEnabled(): boolean {
		return this.configService.get((x) => x.common.geofencing?.argentina?.isEnabled, false);
	}

	getCurrentLocationEndpoint(): string {
		return this.configService.get((x) => x.common.geofencing?.argentina?.currentLocationUrl, "v2/current-location");
	}

	getArgentinaGeoFenceExemptRoutes(): string[] {
		return this.configService.get((x) => x.common.geofencing?.argentina?.exemptRoutes, []);
	}

	getArgentinaNavigateToUrl(locationId: string): string {
		return this.configService.get(
			(x) => x.common.geofencing?.argentina?.navigateToUrls.find((u) => u.locationId === locationId)?.url,
			""
		);
	}

	getArgentinaValidLocationIds(): string[] {
		return this.configService.get((x) => x.common.geofencing?.argentina?.validLocationIds, []);
	}

	isAwsLocationServiceEnabled(): boolean {
		return this.configService.get((x) => x.common.geofencing?.awsLocationService?.isEnabled, false);
	}

	getAwsLocationServiceEndpoint(): string {
		return this.configService.get((x) => x.common.geofencing?.awsLocationService?.apiUrl, "v1/current-location");
	}

	getAwsBlockedAdministrativeArea(): string {
		return this.configService.get((x) => x.common.geofencing?.awsLocationService?.administrativeArea, "Ontario");
	}

	getIpBlockedCountry(): string {
		return this.configService.get((x) => x.common.geofencing?.awsLocationService?.country, "Canada");
	}

	isWageringBlockDialogEnabled(): boolean {
		return this.configService.get(
			(x) => x.common.geofencing?.awsLocationService?.isWageringBlockDialogEnabled,
			false
		);
	}

	getDisableExperimentKey(): string {
		return this.configService.get((x) => x.common.geofencing?.disableExperimentKey, "gfo");
	}
}
